var _sodipodi, _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgGroup03Delete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 90",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _sodipodi || (_sodipodi = /*#__PURE__*/React.createElement("sodipodi", {
    id: "namedview2",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 123,
    height: 92,
    id: "rect1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48,
    y: 0.49,
    width: 120,
    height: 90,
    id: "rect2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 69,38 v 6.589999 l -3,-3.01 -4,4.01 -4,-4 -4,4 -3,-3.01 V 38 c 0,-1.1 0.9,-2 2,-2 h 14 c 1.1,0 2,0.9 2,2 z m -3,6.419999 3,3.01 v 4.57 c 0,1.1 -0.9,2 -2,2 H 53 c -1.1,0 -2,-0.9 -2,-2 v -6.58 l 3,2.99 4,-4 4,4 z",
    id: "path3",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 123,
    height: 92,
    id: "rect1-2",
    style: {
      opacity: 0.5
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGroup03Delete);
export default __webpack_public_path__ + "static/media/img_group_03_delete.72e85faceb602c77dc4994ce44ba8605.svg";
export { ForwardRef as ReactComponent };